import { render, staticRenderFns } from "./EventTicketsList.vue?vue&type=template&id=ac328262&"
import script from "./EventTicketsList.vue?vue&type=script&lang=js&"
export * from "./EventTicketsList.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports